import { render, staticRenderFns } from "./AssessmentTaskSideFilter.vue?vue&type=template&id=26b6935e&"
import script from "./AssessmentTaskSideFilter.vue?vue&type=script&lang=js&"
export * from "./AssessmentTaskSideFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports